import React from "react";

const OddEvenMobile = ({ t, numberItems = [] }) => {
    const rows = [];

    for (let i = 0; i < numberItems.length; i++) {
        const rowColor = numberItems[i] || [];
        const cols = [];

        for (let j = 0; j < rowColor.length; j++) {
            const col = rowColor[j];
            const colorCode = col?.length > 0 ? col.split("_")[0] : "";
            const valueCode = col?.length > 0 ? col.split("_")[1] : "";

            cols.push(
                <td key={`${i}-${j}`} className="rhm-table__cell">
                    {col?.length > 0 ? (
                        <div className="rhm-cell">
              <span className={`rhm-oe bg-oe-${colorCode}`}>
                {t("labels:drawing.drawPrefix.S_" + valueCode)}
              </span>
                        </div>
                    ) : (
                        <div className="rhm-cell rhm-cell--empty" />
                    )}
                </td>
            );
        }

        rows.push(<tr key={i}>{cols}</tr>);
    }

    return rows;
};

export default OddEvenMobile;